/* Standalone header controller. No React or theme-global event overrides. */
(() => {
  const tag = 'ts-header';
  if (customElements.get(tag)) return;
  class TimeServedSection extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); (this.cleanups || []).forEach(fn => fn()); this.classList.remove('ts-enhanced'); }
    init() {
      this.controller?.abort(); (this.cleanups || []).forEach(fn => fn());
      this.controller = new AbortController(); this.cleanups = [];
      const root = this, signal = this.controller.signal;
      const on = (node, event, fn) => { if (node) node.addEventListener(event, fn, {signal}); };
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const animated = () => root.dataset.animations === 'true' && !reduce.matches;
      const targets = root.querySelectorAll('[data-reveal]');
      if (animated() && 'IntersectionObserver' in window) {
        root.classList.add('ts-enhanced');
        const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) {entry.target.classList.add('ts-in'); observer.unobserve(entry.target);} }), {threshold:.12});
        targets.forEach(el => observer.observe(el)); this.cleanups.push(() => observer.disconnect());
      }
      on(reduce, 'change', () => { if (reduce.matches) {root.classList.remove('ts-enhanced'); targets.forEach(el => el.classList.add('ts-in'));} });
      on(root, 'click', event => {
        const link = event.target.closest('a[href]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || link.target === '_blank') return;
        const href = link.getAttribute('href'); if (!href?.startsWith('#') || href.length < 2) return;
        let key; try { key = decodeURIComponent(href.slice(1)); } catch {return;}
        const target = document.getElementById(key) || [...document.querySelectorAll('[data-ts-anchor]')].find(el => el.dataset.tsAnchor === key);
        if (target) { event.preventDefault(); target.scrollIntoView({behavior: animated() ? 'smooth' : 'auto', block:'start'}); history.replaceState(null,'',href); }
      });
      const productForm = root.querySelector('.ts-product-form');
      if (productForm) {
        const variants = productForm.querySelector('[data-variant]'), add = productForm.querySelector('[data-add]'), quantity = productForm.querySelector('[name="quantity"]'), price = productForm.querySelector('[data-price]');
        const label = price?.textContent.slice(0, -((variants?.selectedOptions[0]?.dataset.price || '').length)) || '';
        on(variants,'change',()=> { const option = variants.selectedOptions[0]; if (!option) return;
          add.disabled = option.dataset.available !== 'true'; add.textContent = add.disabled ? add.dataset.soldOut : add.dataset.label;
          if(price) price.textContent = label + option.dataset.price;
          if(quantity) {quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1'; if(option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max'); quantity.value = quantity.min;}
        });
      }
      const menu = root.querySelector('details');
      on(root,'click',event=> {if(event.target.closest('nav a')) menu.open = false;});
      on(root,'keydown',event=>{if(event.key === 'Escape') {menu.open = false;menu.querySelector('summary').focus();}});
    }
  }
  customElements.define(tag,TimeServedSection);
})();
